<template>
    <v-app id="inspire">
        <app-drawer></app-drawer>
        <app-toolbar></app-toolbar>
        <v-content>
            <transition name="fade">
                <router-view/>
            </transition>
            <app-loader></app-loader>
            <v-snackbar
                auto-height
                v-model="$store.getters.snackbar.display"
                :bottom="$store.getters.snackbar.y === 'bottom'"
                :left="$store.getters.snackbar.x === 'left'"
                :multi-line="$store.getters.snackbar.mode === 'multi-line'"
                :right="$store.getters.snackbar.x === 'right'"
                :timeout="$store.getters.snackbar.timeout"
                :top="$store.getters.snackbar.y === 'top'"
                :vertical="$store.getters.snackbar.mode === 'vertical'"
                >
                {{ $store.getters.snackbar.text }}
                <v-btn
                    color="pink"
                    flat
                    @click="snackbar"
                >
                    Zapri
                </v-btn>
            </v-snackbar>
        </v-content>
        <app-fab></app-fab>
    </v-app>
</template>

<script>
import AppDrawer from '@/views/layout/AppDrawer'
import AppToolbar from '@/views/layout/AppToolbar'
import AppFab from '@/components/AppFab'

export default {
    components: {
        AppDrawer,
        AppToolbar,
        AppFab
    }, 

    props: {
      source: String
    },

    data: () => ({

    }),

    watch: {

    },

    computed: {

    },

    methods: {
         user() {
            return this.$store.getters.user
        },

        snackbar() {
            this.$store.state.snackbar.display = false
        }
    },

    created() {

    },

    mounted() {

    },

    destroyed() {

    }
}
</script>

<style>
    html { overflow-y: auto !important; }
    
    .pointer {cursor: pointer;}

    .fade-enter-active, .fade-leave-active {
        transition-property: opacity;
        transition-duration: .15s;
    }

    .fade-enter-active {
        transition-delay: .15s;
    }

    .fade-enter, .fade-leave-active {
        opacity: 0
    }

    .listMarginLeft {
        margin-left:-10px !important;
    }
</style>


